import React from 'react'
import EdcatoHero from './Edcato_Hero';
import DetailedFeatures from './DetailedFeatures';
import FlowchartDesign from './FlowchartDesign';
import EdcatoButton from './EdcatoButton';

const Edcatoindex = () => {
  return (
    <div>
      <EdcatoHero />
      <DetailedFeatures />
      <FlowchartDesign />
      <EdcatoButton />
    </div>
  )
}

export default Edcatoindex